// provider.reducer.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { fetchAllAppointmentTypes } from '@store/actions/appointment-type.action'
import { IAppointmentType } from '@dataTypes/appointment.type'

interface AppointmentTypeState {
  data: IAppointmentType[] | []
  loading: boolean
  error: string | null
}

const initialState: AppointmentTypeState = {
  data: [],
  loading: false,
  error: null,
}

const AppointmentType = createSlice({
  name: 'appointmenttype',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Fetch Procedures
    builder
      .addCase(fetchAllAppointmentTypes.pending, (state) => {
        state.loading = true
        state.error = null
      })

      .addCase(
        fetchAllAppointmentTypes.fulfilled,
        (state, action: PayloadAction<IAppointmentType[]>) => {
          state.data = action.payload
          state.loading = false
          state.error = null
        },
      )
      .addCase(fetchAllAppointmentTypes.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })

    // Matcher
    builder.addMatcher(
      (action) =>
        action.type.startsWith('api/appointmenttype') &&
        action.type.endsWith('/pending'),
      (state) => {
        state.loading = true
      },
    )
    builder.addMatcher(
      (action) =>
        action.type.startsWith('api/appointmenttype') &&
        action.type.endsWith('/rejected'),
      (state) => {
        state.error = 'Failed to process request'
        state.loading = false
      },
    )
  },
})

export default AppointmentType.reducer
